import { visionLabApi } from '@/app/apiClient';
import type {
  AvailableOperationsResponse,
  PermissionTarget,
  TargetOperationsResponse,
} from '@/features/authentication/types/permissions';
import type { ApiCallOptions } from '@/shared/api/client';

/** True-only Operation availability for global navigation and entry-point hints. */
export async function fetchAvailableOperations(
  options: ApiCallOptions = {},
): Promise<AvailableOperationsResponse> {
  return visionLabApi.get<AvailableOperationsResponse>('/me/permissions/v3', options);
}

/** Exact true-only Operation maps for a bounded Organization/Project selection. */
export async function fetchTargetOperations(
  targets: readonly PermissionTarget[],
  options: ApiCallOptions = {},
): Promise<TargetOperationsResponse> {
  return visionLabApi.post<TargetOperationsResponse>('/me/permissions/v3/targets', {
    ...options,
    json: { targets },
  });
}
